import { FC, ReactNode } from "react";
import { DrawerHeader, DrawerSubtitle, DrawerTitle } from "@rmwc/drawer";
import Text from "../../../DataDisplay/Text";
import { ThemeType } from "../../../../commons/theme";

type SidebarHeaderProps = {
  icon: ReactNode;
  subtitle?: string;
};

const styleLogo = {
  marginLeft: 5,
  marginRight: 5,
  display: "inline-flex",
  padding: 6,
};

const headerStyle = {
  boxShadow: "0 0 12px 0px #00000040",
};

const SidebarHeader: FC<SidebarHeaderProps> = ({ children, icon, subtitle }) => {
  return (
    <DrawerHeader css={headerStyle}>
      <DrawerTitle>
        <span style={styleLogo}>{icon}</span>
        <Text tag={"span"} themeType={ThemeType.DARK}>
          {children}
        </Text>
      </DrawerTitle>
      <DrawerSubtitle>
        <Text type={"textHint"} tag={"span"} themeType={ThemeType.DARK}>
          {subtitle}
        </Text>
      </DrawerSubtitle>
    </DrawerHeader>
  );
};

export default SidebarHeader;
